module.exports = __webpack_public_path__ + "nc_static/media/exclamatory.6820ee4e.svg";